import axios from 'axios';


export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};


export const instance = axios.create({
  baseURL: `${window.location.origin}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true,
});

export const documentKeys = payload => {

  return Object.keys(payload).filter(
    v => v.startsWith('ben') || v.startsWith('aud')
  );
}

export const carrierKeys = payload => {
  const additionalCarrierKeysList = [
    'companyName',
    'abiVat',
    'regDate',
    'mainKAD',
    'mainKADDescription',
    'companyLegalType',
    'companySize',
    'abiStreetFull',
    'abiStreet',
    'abiTk',
    'abiPerfecture',
    'birthDate',
    'abiDistrict',
    'invMob',
    'website',
    'invMail',
    'legalSurname',
    'legalFather',
    'legalAdt',
    'legalName',
    'legalVat',
    'legalPhone',
    'legalPhoneValidated',
    'legalVat',
    'legalEmail',
    'legalEmailValidated',
    'legalPhoneMobile',
    'legalPhoneMobileValidated',
    'contactSurname',
    'contactName',
    'contactVat',
    'contactPhone',
    'contactPhoneValidated',
    'contactVat',
    'contactEmail',
    'contactEmailValidated',
    'buildDistrict',
    'buildAddress',
    'buildStreet',
    'buildTk',
    'buildPerfecture',
    'buildMunicipalityName',
    'carrierShareHolders',
    'carrierShareHolders2',
    'sumCheckShareHolders',
    'addresses',
    'totalAmountSorefsis',
    'otherReasonCheck',
    'otherReasonDescription',
    'checkUniqueAfm',
    'checkUniqueKaek',
    'contactPersonFlag',
    'otherShareholdersFlag',
    'otherShareholdersFlag2',
    'singleCompanyFlag',
    'singleCompanies',
    'coverid',
    'rejectKtpReason',
    'rejectKtpMessage',
    'propertyType',
    'floor',
    'addressLoc',
    'tkLoc',
    'perfectureLoc',
    'district',
    'photoPower',
    'storagePower',
    'connectionDetails',
    'publicExpPerc',
    'amountInvestmentPlan',
    'reductionForecast',
    'indicator',
    'evaluationCheck',
    'rejectAuditorReason',
    'rejectAuditorMessage',
  ];
  return Object.keys(payload).filter(
    v => v.startsWith('abi') || additionalCarrierKeysList.includes(v)
  );
};

export const AssetKeys = payload =>
  Object.keys(payload).filter(
    v =>
      v.startsWith('businessPlanAssets') || 
      v.startsWith('InvestmentTotalAmountTable') || 
      v.startsWith('businessPlanCoverage') ||
      v.startsWith('mainKads') ||
      v.startsWith('addKads')
  );


export const termsKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('term')
  );

export const xedmKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('details')
  );

export const objectionInvestorKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objInv'));
};

export const objectionCommitteeKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objCommittee'));
};



export const projectPlanInfoKeys = payload => {
  const additionalProjectPlanInfoKeysList = ['projectPlans', 'messages', 'timestamp'];
  return Object.keys(payload).filter(v =>
    additionalProjectPlanInfoKeysList.includes(v)
  );
};



